<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;  /* 禁止水平滚动 */
}

body {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 隐藏滚动条但保持可滚动 */
::-webkit-scrollbar {
  width: 0;  /* 移除滚动条 */
}

#app {
  width: 100%;
  overflow-x: hidden;  /* 禁止水平滚动 */
}
</style> 